// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-external {
   background-color: #fff;
   border: 1px solid rgba(0, 0, 0, .1);
   /* margin: auto; */
   padding: 30px 40px;
   position: relative;
   width: 100%;
   min-width: 380px;
}

.content-external-completed {
   margin-top: 6px;
   margin-bottom: 1em;
   text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/external-completed/external-completed.component.css"],"names":[],"mappings":"AAAA;GACG,sBAAsB;GACtB,mCAAmC;GACnC,kBAAkB;GAClB,kBAAkB;GAClB,kBAAkB;GAClB,WAAW;GACX,gBAAgB;AACnB;;AAEA;GACG,eAAe;GACf,kBAAkB;GAClB,kBAAkB;AACrB","sourcesContent":[".section-external {\n   background-color: #fff;\n   border: 1px solid rgba(0, 0, 0, .1);\n   /* margin: auto; */\n   padding: 30px 40px;\n   position: relative;\n   width: 100%;\n   min-width: 380px;\n}\n\n.content-external-completed {\n   margin-top: 6px;\n   margin-bottom: 1em;\n   text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
